import {BehaviorSubject, Observable, switchMap, tap} from 'rxjs';
import {ApiService} from '../apiModule1/api/ApiService';
import {map} from 'rxjs/operators';

export class OnInputChange<T>{
  private subj$ = new BehaviorSubject<string>('');

  set(x: string) {
    if (typeof x !== 'string') return;
    this.subj$.next(x);
  }

  constructor(private service: ApiService,private method: string, private filteredObjectName: string = '') {
    this.method = method;
  }

  on(arg?: object): Observable<T[]> {
    const args = arg || {};
    return this.subj$
      .pipe(switchMap((v: string) => (this.service as any)[this.method]({filteredObjectName: this.filteredObjectName, searchString: v, ...args})))
      .pipe(tap(v=>console.log(v)))
      .pipe(map((v: any) => v?.values))
  }
}
